import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, CircularProgress } from '@material-ui/core'
import CompanyLogo from '../../../app/components/companyLogo'
import ForgotPassword from '../forgotPassword'
import { LoginTitle, StyledButton, StyledExternalLink, StyledTextField } from '../../../theme/Global'
import { CustomFullPageWrapper, CustomPaper } from './styles'
import { SupportedBrowsersHelpIcon } from '../SupportedBrowsersHelpIcon'
import LoginDialog from '../loginDialog/index'
import { Modal } from '../../../common/components/modal'
import { ACCOUNT } from '../../../common/enum/account'
import { ExpiredSessionModal } from '../expiredSessionModal'

const LoginRenderer = ({
  anchorEl,
  loginError,
  onChangePassword,
  onChangeUsername,
  onKeyPress,
  onCloseError,
  password,
  setShowForgotPassword,
  showForgotPassword,
  setShowErrorMessage,
  status,
  submit,
  username,
  setAnchorEl,
  newSubmit,
  cognitoForgotPasswordSubmit,
  cognitoResendTemporalPassword,
  location: locationProp
}) => {
  const [showExpiredSessionModal, setShowExpiredSessionModal] = useState(locationProp.search === `?${ACCOUNT.SESSION_EXPIRED}`)
  return (
    <CustomFullPageWrapper>
      <Modal
        open={showExpiredSessionModal}
        data-testid="login-sessionExpired"
        title=""
        component={(<ExpiredSessionModal {... { setShowExpiredSessionModal }} />)}
        modalCloseDispatch={() => setShowExpiredSessionModal(false)}
        isFullWidth
        maxWidth="sm"
        unsetHeight
      />
      <Grid
        container
        justify="center"
        style={{
          width: '100%',
          margin: 0
        }}
      >
        <Grid item xs={12} lg={12}>
          <CustomPaper>
            <SupportedBrowsersHelpIcon setAnchorEl={setAnchorEl} anchorEl={anchorEl} />
            {showForgotPassword
              ? cognitoForgotPasswordSubmit
                ? (
                  <ForgotPassword
                    cognitoForgotPasswordSubmit={cognitoForgotPasswordSubmit}
                    cognitoResendTemporalPassword={cognitoResendTemporalPassword}
                    onLogIn={() => {
                      setShowForgotPassword(false)
                    }}
                  />
                ) : <ForgotPassword onLogIn={() => { setShowForgotPassword(false) }} />
              : (
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <CompanyLogo size="login" color />
                  </Grid>

                  <Grid item xs={12}>
                    <LoginTitle>Log In</LoginTitle>
                    <LoginDialog {...{ errorText: loginError, error: loginError, onCloseError, setShowErrorMessage }} />
                  </Grid>
                  <Grid item xs={12}>
                    <StyledTextField
                      name="username"
                      fullWidth
                      label="Email Address"
                      onChange={onChangeUsername}
                      onKeyPress={onKeyPress}
                      value={username}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <StyledTextField
                      name="password"
                      fullWidth
                      label="Password"
                      onChange={onChangePassword}
                      type="password"
                      onKeyPress={onKeyPress}
                      value={password}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={24}
                      direction="row"
                      justify="flex-start"
                      alignItems="center"
                    >
                      <Grid item>
                        <StyledButton disabled={!!loginError || status === 'attempting'} onClick={newSubmit || submit}>
                          {status === 'attempting' ? <CircularProgress size={16} style={{ marginRight: '10px' }} /> : null}
                          Log In
                        </StyledButton>
                      </Grid>
                      <Grid
                        item
                        style={{ paddingLeft: '24px' }}
                      >
                        <StyledExternalLink
                          onClick={() => {
                            setShowForgotPassword(true)
                          }}
                          onKeyPress={() => {
                            setShowForgotPassword(true)
                          }}
                          tabIndex={0}
                        >
                          Forgot Password?
                        </StyledExternalLink>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
          </CustomPaper>
        </Grid>
      </Grid>
    </CustomFullPageWrapper>
  )
}

LoginRenderer.propTypes = {
  onChangePassword: PropTypes.func.isRequired,
  onChangeUsername: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  setShowForgotPassword: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  setAnchorEl: PropTypes.func.isRequired
}

export default LoginRenderer
